import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../../firebase";
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import VideoUploadForm from "../VideoUploadForm/VideoUploadForm";
import VideoList from "../VideoList/VideoList";
import PdfUploadForm from "../PdfUploadForm/PdfUploadForm";
import PdfList from "../PdfList/PdfList";
import NewsUploadForm from "../NewsUploadForm/NewsUploadForm";
import NewsList from "../NewsList/NewsList";
import Modal from "../../../components/Modal/Modal";
import styles from "./CompanyDetail.module.css";

const CompanyDetail = () => {
  const { companyId } = useParams();
  const formattedCompanyId = decodeURIComponent(companyId);
  const [company, setCompany] = useState(null);
  const [videos, setVideos] = useState({});
  const [pdfs, setPdfs] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [isNewsModalOpen, setIsNewsModalOpen] = useState(false);

  useEffect(() => {
    const fetchCompany = async () => {
      if (!formattedCompanyId) {
        console.error("❌ 회사 ID가 없음");
        setLoading(false);
        return;
      }

      try {
        const docRef = doc(db, "companies", formattedCompanyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const companyData = { id: formattedCompanyId, ...docSnap.data() };
          setCompany(companyData);
          setVideos(companyData.videos || {});
          setPdfs(companyData.pdfs || []);
          setNews(companyData.news || []);
        } else {
          console.error("❌ Firestore에서 해당 회사 정보를 찾을 수 없음");
        }
      } catch (error) {
        console.error("🔥 Firestore에서 회사 정보 불러오기 실패:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, [formattedCompanyId]);

  const handleNewsSubmit = async (title, content) => {
    try {
      const newsItem = { title, content, date: new Date().toISOString() };
      const companyRef = doc(db, "companies", formattedCompanyId);
      await updateDoc(companyRef, {
        news: arrayUnion(newsItem),
      });
      setNews((prev) => [...prev, newsItem]);
    } catch (error) {
      console.error("뉴스 등록 실패:", error);
    }
  };

  if (loading) return <p>⏳ 로딩 중...</p>;
  if (!company) return <p>⚠️ 회사 정보를 찾을 수 없습니다.</p>;

  return (
    <div className={styles.container}>
      <h2>{company.name}</h2>

      <div className={styles.uploadSection}>
        <div className={styles.uploadBox}>
          <button
            className={styles.uploadButton}
            onClick={() => setIsVideoModalOpen(true)}
          >
            🎬 영상 업로드
          </button>
          <VideoList
            videos={videos}
            companyId={companyId}
            setVideos={setVideos}
          />
        </div>

        <div className={styles.uploadBox}>
          <button
            className={styles.uploadButton}
            onClick={() => setIsPdfModalOpen(true)}
          >
            📄 PDF 업로드
          </button>
          <PdfList pdfs={pdfs} />
        </div>

        <div className={styles.uploadBox}>
          <button
            className={styles.uploadButton}
            onClick={() => setIsNewsModalOpen(true)}
          >
            📰 뉴스 쓰기
          </button>
          <NewsList news={news} />
        </div>
      </div>

      {isVideoModalOpen && (
        <Modal onClose={() => setIsVideoModalOpen(false)}>
          <VideoUploadForm companyId={companyId} setVideos={setVideos} />
        </Modal>
      )}
      {isPdfModalOpen && (
        <Modal onClose={() => setIsPdfModalOpen(false)}>
          <PdfUploadForm
            companyId={companyId}
            setPdfs={setPdfs}
            onClose={() => setIsPdfModalOpen(false)} // ✅ 업로드 후 모달 닫기
          />
        </Modal>
      )}

      {isNewsModalOpen && (
        <Modal onClose={() => setIsNewsModalOpen(false)}>
          <NewsUploadForm companyId={companyId} setNews={setNews} />
        </Modal>
      )}
    </div>
  );
};

export default CompanyDetail;
